// src/analytics/track.js
import { Capacitor } from "@capacitor/core";
import { afTrack } from "./appsflyer";

let lastPageKey = null;
let lastScreenName = null;

/**
 * One analytics entry point for app + web.
 *
 * afTrack() now:
 *   - sends native events to AppsFlyer
 *   - sends native events to Firebase/GA4
 *   - sends web events to Firebase/GA4
 */
export async function trackEvent(name, params = {}) {
  return afTrack(name, params);
}

export async function trackPageView({
  url,
  title,
  referrer,
  location,
} = {}) {
  if (!url) return;

  // Prevent duplicate SPA page views on rerenders / React StrictMode.
  const key = `${url}|${title || ""}`;
  if (key === lastPageKey) return;
  lastPageKey = key;

  return trackEvent("page_view", {
    page_path: url,
    page_location:
      location ||
      (typeof window !== "undefined"
        ? window.location.href
        : ""),
    page_title:
      title ||
      (typeof document !== "undefined"
        ? document.title
        : ""),
    page_referrer:
      referrer ||
      (typeof document !== "undefined"
        ? document.referrer
        : ""),
  });
}

export async function trackScreenView({
  screenName,
  screenClass,
} = {}) {
  // GA4 web should use page_view. Keep screen_view app-only.
  if (!Capacitor.isNativePlatform()) return;
  if (!screenName) return;

  if (screenName === lastScreenName) return;
  lastScreenName = screenName;

  return trackEvent("screen_view", {
    screen_name: screenName,
    screen_class: screenClass || screenName,
  });
}
